import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { ToastProvider } from './components/ToastProvider';
import { AuthProvider } from './hooks/useAuth';
import { AdminLayout } from './layouts/AdminLayout';
import { DashboardPage } from './pages/DashboardPage';
import { LoginPage } from './pages/LoginPage';
import { VpnKeyDetailPage } from './pages/VpnKeyDetailPage';
import { VpnPage } from './pages/VpnPage';
import { SettingsPage } from './pages/SettingsPage';
import { PaymentDetailPage } from './pages/PaymentDetailPage';
import { PaymentsPage } from './pages/PaymentsPage';
import { PromosPage } from './pages/PromosPage';
import { TariffsPage } from './pages/TariffsPage';
import { ReferralRulesPage } from './pages/ReferralRulesPage';
import { ServersPage } from './pages/ServersPage';
import { SupportPage } from './pages/SupportPage';
import { UserDetailPage } from './pages/UserDetailPage';
import { UsersPage } from './pages/UsersPage';

export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<AdminLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="users/:userId" element={<UserDetailPage />} />
            <Route path="support" element={<SupportPage />} />
            <Route path="vpn" element={<VpnPage />} />
            <Route path="vpn/:keyId" element={<VpnKeyDetailPage />} />
            <Route path="servers" element={<ServersPage />} />
            <Route path="payments" element={<PaymentsPage />} />
            <Route path="payments/:paymentId" element={<PaymentDetailPage />} />
            <Route path="promos" element={<PromosPage />} />
            <Route path="tariffs" element={<TariffsPage />} />
            <Route path="referral-rules" element={<ReferralRulesPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ToastProvider>
    </AuthProvider>
  );
}
